export interface WashSummary {
  titulo: string;
  descripcion: string;
  incluye: string[];
  funcionamiento: { icon: string; text: string }[];
  requisitos: { icon: string; text: string }[];
  precio: number;
}

export const WASH_SUMMARY: { [key: string]: WashSummary } = {
  interior: {
    titulo: 'interior-wash-title',
    descripcion:
      'interior-wash-description',
    incluye: [
      'include-text-1',
      'include-text-2',
      'include-text-3',
      'include-text-4',
    ],
    funcionamiento: [
      {
        icon: 'calender-icon',
        text: 'how-does-it-work-text-1',
      },
      {
        icon: 'driver-icon',
        text: 'how-does-it-work-text-2',
      },
      {
        icon: 'center-icon',
        text: 'how-does-it-work-text-3',
      },
      {
        icon: 'location-icon',
        text: 'how-does-it-work-text-4',
      },
    ],
    requisitos: [
      {
        icon: 'document-ok-icon',
        text: 'requirements-for-solicitude-text-1',
      },
      {
        icon: 'document-text-icon',
        text: 'requirements-for-solicitude-text-2',
      },
      {
        icon: 'document-insurance-icon',
        text: 'requirements-for-solicitude-text-3',
      },
      {
        icon: 'refuel-icon',
        text: 'requirements-for-solicitude-text-4',
      },
    ],
    precio: 20.5,
  },
  exterior: {
    titulo: 'exterior-wash-title',
    descripcion:
      'exterior-wash-description',
    incluye: [
      'include-text-5',
      'include-text-6',
    ],
    funcionamiento: [
      {
        icon: 'calender-icon',
        text: 'how-does-it-work-text-1',
      },
      {
        icon: 'driver-icon',
        text: 'how-does-it-work-text-2',
      },
      {
        icon: 'center-icon',
        text: 'how-does-it-work-text-3',
      },
      {
        icon: 'location-icon',
        text: 'how-does-it-work-text-4',
      },
    ],
    requisitos: [
      {
        icon: 'document-ok-icon',
        text: 'requirements-for-solicitude-text-1',
      },
      {
        icon: 'document-text-icon',
        text: 'requirements-for-solicitude-text-2',
      },
      {
        icon: 'document-insurance-icon',
        text: 'requirements-for-solicitude-text-3',
      },
      {
        icon: 'refuel-icon',
        text: 'requirements-for-solicitude-text-4',
      },
    ],
    precio: 23.5,
  },
  completo: {
    titulo: 'complete-wash-title',
    descripcion:
      'complete-wash-description',
    incluye: [
      'include-text-5',
      'include-text-6',
      'include-text-1',
      'include-text-2',
      'include-text-3',
      'include-text-4',
    ],
    funcionamiento: [
      {
        icon: 'calender-icon',
        text: 'how-does-it-work-text-1',
      },
      {
        icon: 'driver-icon',
        text: 'how-does-it-work-text-2',
      },
      {
        icon: 'center-icon',
        text: 'how-does-it-work-text-3',
      },
      {
        icon: 'location-icon',
        text: 'how-does-it-work-text-4',
      },
    ],
    requisitos: [
      {
        icon: 'document-ok-icon',
        text: 'requirements-for-solicitude-text-1',
      },
      {
        icon: 'document-text-icon',
        text: 'requirements-for-solicitude-text-2',
      },
      {
        icon: 'document-insurance-icon',
        text: 'requirements-for-solicitude-text-3',
      },
      {
        icon: 'refuel-icon',
        text: 'requirements-for-solicitude-text-4',
      },
    ],
    precio: 29.99,
  },
};
